import { useEffect, useState } from "react";
import Book from "../interface/BookInterface";
import { AxiosResponse } from "axios";
import BlogPost from "../interface/BlogPostInterface";
import Chapter from "../interface/ChapterInterface";
import Solution from "../interface/SolutionInterface";
import apiService from "../services/api.service";

const adminUseFetchSiteMaterials = () => {
  const [books, setBooks] = useState<Book[]>([]);
  const [blogposts, setBlogposts] = useState<BlogPost[]>([]);
  const [chapters, setChapters] = useState<Chapter[]>([]);
  const [solutions, setSolutions] = useState<Solution[]>([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          bookResponse,
          blogpostResponse,
          chapterResponse,
          solutionResponse,
        ] = await Promise.all([
          apiService.get<AxiosResponse>(`/books/`),
          apiService.get<AxiosResponse>(`/blogposts/`),
          apiService.get<AxiosResponse>(`/chapters/`),
          apiService.get<AxiosResponse>(`/solutions/`),
        ]);

        setBooks(bookResponse.data);
        setBlogposts(blogpostResponse.data);
        setChapters(chapterResponse.data);
        setSolutions(solutionResponse.data);
      } catch (error) {
        if (error instanceof Error) {
          console.error(error);
        }
      }
    };
    fetchData();
  }, []);
  return { books, blogposts, chapters, solutions };
};
export default adminUseFetchSiteMaterials;
